import React, { createContext,useContext, useEffect, useRef, useState } from 'react'

var authContext = createContext();
let prodURL = "https://vai.docsun.health/api/videosdk";

export function useAuth() {
    const login = async (uname,pass)=>{
        let data = {
            'email':uname,
            'password':pass,
            'app_name':'vai'
        };
        let response = await fetch(`${prodURL}/auth/login`,{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify(data)
        })
        response = await response.json();
        if (response.success){
            localStorage.setItem("status",true)
            // localStorage.setItem("licence",response.licencekey);
            // localStorage.setItem("token",response.accessToken);
            return {
                status:true,message:response.message,accessToken:response.result.accessToken,licencekey:response.result.licencekey,id:response.result.id
            }
        }else{
            localStorage.setItem("status",false)
            return {
                status:false,
                message:response.message,
                accessToken:'',
                licencekey:'',
                id:''
            }
        }
    }
  return {
    login,
    };
}
export function AuthProvider({children}){
    var auth = useAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>
}
export default function AuthConsumer(){
    return useContext(authContext);
}